import { numberFormatter } from '@flipster/utils/num';

/**
 * Secondary (ROI / PnL / Change%) → absolute price tick.
 * ROUND_DOWN (toward zero) so converted prices floor to `pricePrecision`.
 * Direct price input and qty snapping stay HALF_DOWN at their call sites.
 * https://prextech.slack.com/archives/C0AQX0CL77F/p1786695485122119
 */
export function formatTpslConvertedPrice(price: string, pricePrecision: number): string {
  if (price === '') return '';
  return numberFormatter(price, { method: 'round-down', precision: pricePrecision, withComma: false });
}
